export default (type, colors) => {
  const styles = {
    type1: {
      'profile-form__h3': {
        marginBottom: '30px'
      },
      'profile-form__label': {
        color: colors.dark
      },
      'profile-form__input': {
        marginBottom: '25px',
        height: '42px'
      },
      'profile-form__form-actions': {
        border: 'none'
      },
      'profile-form__button': {
        minWidth: '142px',
        height: '42px',
        borderRadius: '3px',
        boxShadow: 'none',
        lineHeight: 'inherit',
        paddingLeft: '30px',
        paddingRight: '30px'
      }
    }
  }

  return styles[type]
}


// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/profileForm.js